export const COOKIE_KEY = "token_enermatch";

export const getTokenFromCookie = () => {
  const cookies = document.cookie.split("; ");

  return cookies.reduce((token, cookie) => {
    if (cookie.startsWith(COOKIE_KEY)) {
      const [, value] = cookie.split("=");
      return value;
    } else return token;
  }, "");
};

export const setTokenCookie = (token) => {
  document.cookie = `${COOKIE_KEY}=${token || ""}; path=/`;
};

export const clearTokenCookie = () => {
  const updatedCookies = document.cookie
    .split("; ")
    .map((cookie) =>
      cookie.startsWith(COOKIE_KEY) ? `${COOKIE_KEY}=` : cookie
    )
    .join("; ");
  document.cookie = updatedCookies;
};
